import { string, addMethod } from 'yup'

// `unique` doğrulama metodunu Yup'a ekleyin
addMethod(string, 'unique', function (fieldName, message) {
  return this.test('unique', message, function (value) {
    if (!value) return true

    // variationState'e erişim
    const variationState = useVariationStore()
    const allVariations = variationState.variations

    // Aynı fieldName alanına sahip duplicate varsa hata döndür
    const isDuplicate = allVariations.some(
      (variation) => variation !== this.parent && variation[fieldName] === value
    )

    return !isDuplicate || this.createError({ path: this.path, message })
  })
})

// Nuxt plugin olarak export ediyoruz
export default defineNuxtPlugin(() => {
  // Eklenti yüklendiğinde yalnızca Yup'a özel doğrulama metodu eklenir.
  // Başka bir işlem yapmamıza gerek yok.
})
